import $ from 'jquery'
import Cookies from 'js-cookie'


document.addEventListener('DOMContentLoaded', function () {
  const notif = $('.part-notification')
  const notifIsClose = sessionStorage.getItem('notification-is-close')
  if(notifIsClose){
    notif.hide()
  }
  $('.js-close-notif').on('click', function(e) {
    e.preventDefault()
    sessionStorage.setItem('notification-is-close', 'true')
    $('.part-notification').slideToggle()
    document.body.style.setProperty('--notificationbar-height', '0px')
  })
});
